module.exports = __webpack_public_path__ + "static/img/memberLAH.0a59395.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberLAH.png
// module id = u4B3
// module chunks = 0